<template>
  <div ref="galleries" class="galleries"></div>
</template>

<script>
//专馆
import * as echarts from 'echarts';

export default {
  name: "SpecialArea",
  data() {
    return{
      myChart:{},
      option : {

      }
    }
  },
  methods:{
    init(){
      this.myChart= echarts.init(this.$refs.galleries);
      this.myChart.setOption(this.option);
    },
    getPast12Months() {
      const months = [];
      const currentDate = new Date();
      for (let i = 11; i >= 0; i--) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        months.push(`${year}-${month}`);
      }
      return months;
    }
  },
  mounted() {
    //初始化
    // this.init();
  },
  created() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };
    this.$api.zq_broken_line(data).then(res=>
    {
      this.option = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: res.legend_data,
          show:false,
        },
        grid: {
          top:'8%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.getPast12Months(),
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 1,//使x轴文字显示全
          }
        },
        yAxis: {
          type: 'value',
          show: true,    // 是否显示 y 轴

        },
        series: [
          {
            name: res.legend_data[0],
            type: 'line', //折线图line;柱形图bar;饼图pie
            // smooth:true,
            stack: 'z',
            data: res.data[0]
          },
          {
            name: res.legend_data[1],
            type: 'line', //折线图line;柱形图bar;饼图pie
            // smooth:true,
            stack: 'y',
            data:  res.data[1]
          },
          {
            name: res.legend_data[2],
            type: 'line', //折线图line;柱形图bar;饼图pie
            // smooth:true,
            stack: 'x',
            data: res.data[2]
          }

        ]
      }
      this.myChart= echarts.init(this.$refs.galleries);
      this.myChart.setOption(this.option);
    })


  },

}
</script>

<style scoped>
.galleries {
  width: 100%;
  height: 100%;
}
</style>